import { API_URL } from '@/modules/shared/constants/API_URL'
import { httpAuthenticationInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPAuthenticationInterceptor'
import HTTPExceptionInterceptor from '@/modules/shared/modules/http/domain/services/HTTPExceptionInterceptor'
import { httpTokenInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPTokenInterceptor'
import { ClientType } from '@/modules/shared/schemas/ClientType'

import { ReleaseNotesList } from '../domain/models/ReleaseNotes'
import { ReleaseNotesDatasource } from '../infra/datasources/ReleaseNotesDatasource'

export const releaseNotesAdapter: ReleaseNotesDatasource = {
  async getReleaseNotes({
    clientType,
    versionMajorNumber,
    versionMinorNumber
  }: {
    clientType: ClientType
    versionMajorNumber: number
    versionMinorNumber: number
  }) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/release-notes/${versionMajorNumber}/${versionMinorNumber}/${clientType}`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )

    return ReleaseNotesList.parse(await response.json())
  }
}
